@if (order$ | async; as order) { @if (order?.code || order?.purchaseOrderNumber) {
<div class="udex-grid udex-mx-auto udex-mb-16 udex-pb-4">
  <udex-tile class="col-12 col-md-10 udex-mx-auto text-center body--s text-grey">
    @if (order?.code) {
    <div class="d-block d-md-inline-block">
      <span> {{ 'checkoutOrderConfirmation.sapStoreId' | cxTranslate }}&nbsp; </span>
      <span class="heading__bold--xxxxs">
        {{ order?.code }}
      </span>
    </div>
    } @if (order?.purchaseOrderNumber) {
    <div class="d-block d-md-inline-block">
      <span [class.udex-ms-md-8]="order?.code">
        {{ 'checkoutOrderConfirmation.your' | cxTranslate }}
        <abbr [title]="'checkoutOrderConfirmation.purchaseOrder' | cxTranslate"
          >{{ 'checkoutOrderConfirmation.po' | cxTranslate }}
        </abbr>
        {{ 'checkoutOrderConfirmation.hyphenNumber' | cxTranslate }}&nbsp;
      </span>
      <span class="heading__bold--xxxxs">
        {{ order?.purchaseOrderNumber }}
      </span>
    </div>
    }
  </udex-tile>
</div>
} }
